import React from "react";
import { Text, Title } from "react_reusable_components";

import { TwoRow } from "core/layouts";
import Styles from "./headingContainer.module.scss";

export default function HeadingContainer({
  heading,
  description,
  level,
  headingClassName,
  descriptionClassName,
}) {
  return (
    <TwoRow
      topSection={
        <Title
          level={level}
          className={`${Styles["heading-text"]} ${headingClassName} ${
            Styles[
              level === 1 ? "heading-text-level-one" : "heading-text-level-two"
            ]
          }`}
        >
          {heading}
        </Title>
      }
      bottomSection={
        <Text
          className={`${Styles["description-text"]} ${descriptionClassName}`}
        >
          {description}
        </Text>
      }
    />
  );
}
